// Chain identity only. The RPC endpoint is NOT here: it is injected at boot from
// the backend's /appConfig. It reaches the user's wallet through
// wallet_addEthereumChain, so it must be an endpoint that is safe to publish.
export const EVM_NETWORKS = {
  mainnet: {
    chainId: 137,
    chainIdHex: "0x89",
    chainName: "Polygon Mainnet",
    blockExplorerUrl: "https://polygonscan.com",
    nativeCurrency: { name: "POL", symbol: "POL", decimals: 18 },
  },
  testnet: {
    chainId: 80002,
    chainIdHex: "0x13882",
    chainName: "Polygon Amoy Testnet",
    blockExplorerUrl: "https://amoy.polygonscan.com",
    nativeCurrency: { name: "POL", symbol: "POL", decimals: 18 },
  },
} as const;

export type EvmNetwork = keyof typeof EVM_NETWORKS;

/**
 * RPC endpoints, supplied by the host app. No default: adding a chain to a
 * wallet with a wrong or missing endpoint must fail loudly.
 */
const rpcUrls: Partial<Record<EvmNetwork, string>> = {};

export function configureEvmRpcUrls(
  urls: Partial<Record<EvmNetwork, string>>,
): void {
  Object.assign(rpcUrls, urls);
}

export function getEvmRpcUrl(network: EvmNetwork): string {
  const url = rpcUrls[network];
  if (!url) {
    throw new Error(
      `No RPC URL configured for "${network}". The host app must call ` +
        `configureEvmRpcUrls() with the value from /appConfig before connecting a wallet.`,
    );
  }
  return url;
}
